import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import { MultiSelect } from 'react-multi-select-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Modal } from 'react-bootstrap';
import XLSFILE from '../../../../assets/Flight_demo.xlsx'
import Trash from "../../../../assets/images/trash.png";
import { faFileExport, faPlus, faGear, faDownload, faUpload } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import * as XLSX from 'xlsx';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { GETTYPECODE, GETDESTINATION, GETOWNERCODE, GETCONDITIONCODE, ULDADDRESSSAVE, SAVEULDSTOCK } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';

const AddFlight = () => {


    const isMounted = useRef(false);
    const [getTypeCodes, setGetTypeCodes] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [getCondCodes, setGetCondCode] = useState([]);

    const [handlerNames, setHandlerNames] = useState([]);
    const [selectedHandler, setSelectedHandler] = useState(null);
    const [addressModalShow, setAddressModalShow] = useState(false);
    const addressModalClose = () => setAddressModalShow(false);
    const [inputAddress, setInputAddress] = useState({
        id: '', company_name: '', agent_or_handler: 'H', address: '', email: '', phone_number: ''
    });
    const [address, setAddress] = useState([]);
    const [selectedStationId, setSelectedStationId] = useState(null)

    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    let storedData = localStorage.getItem('EditFlight');
    if (storedData) {
        storedData = JSON.parse(storedData)
    }

    useEffect(() => {
        if (storedData) {
            setFormData([storedData])
        }
        // Call the fetchData function to fetch data from the API
        if (isMounted.current) return;
        fetchDestination();
        fetchOwnerCode();
        isMounted.current = true;
    }, []);



    const [showULDStack, setShowULDStack] = useState(false);
    const [formData, setFormData] = useState([
        { id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', departure_time_utc: '', destination: '', arrival_time_utc: '' }
    ]
    );

    const addULDStack = () => {
        const lastId = formData.length > 0 ? parseInt(formData[formData.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setFormData(prevFormData => [
            ...prevFormData,
            {
                // id: (prevFormData.uldStack.length + 1).toString(),
                id: newId,
                flight_code: '', flight_number: '', flight_date: '',
                origin: '', departure_time_utc: '', destination: '', arrival_time_utc: ''
            }
        ]);
    };
    const removeULDStack = (uldInfoId) => {
        setFormData(prevFormData => prevFormData.filter(stack => stack.id !== uldInfoId));
    };
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: type === 'checkbox' ? checked : value };

            // If the field being changed is owner_code, update airline_name accordingly
            if (name === 'destination') {
                const selectedOwner = getDestination.find(owner => owner.port_code === value);
                if (selectedOwner) {
                    newFormData.airline_name = selectedOwner.carrierName;
                } else {
                    newFormData.airline_name = '';
                }
            }

            return newFormData;
        });
    };
    const handleULDInputChange = (uldInfoId, fieldName, value) => {
        setFormData(prevFormData => prevFormData.map(entry => {
            if (entry.id === uldInfoId) {
                return { ...entry, [fieldName]: value };
            }
            return entry;
        }));
    };
    const isLastRowComplete = (uldInfo) => {
        const lastRow = uldInfo[uldInfo.length - 1];
        return lastRow.type_code && lastRow.serial_number && lastRow.owner_code && lastRow.condition_code;
    };

    const handleKeyPress = (event) => {
        console.log('keytype===', event.key);
        if (event.key === 'Tab' && isLastRowComplete(formData.uldInfo)) {
            event.preventDefault();
            addULDStack();
        }
    };
    // console.log('0123', formData);
    // const validateFormData = () => {
    //     let isValid = true;
    //     if (!formData.status) {
    //         toast.error('Please set Status');
    //         isValid = false;
    //     } else if (!formData.destination) {
    //         toast.error('Please select Destination');
    //         isValid = false;
    //     } else if (!formData.boardpoint) {
    //         console.log('Text input is required');
    //         toast.error('Boardpoint must not be blank');
    //         isValid = false;
    //     } else {
    //         return isValid;
    //     }
    // };
    // ADD ADDRESS
    const [addressFor, setAddressFor] = useState('');
    const addressModalOpen = (addressType) => {
        setAddressFor(addressType);
        setAddressModalShow(true)
    }
    const handleAddressChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        console.log(inputAddress);
    };
    let destLabel;
    if (selectedStationId) {
        const idMatch = getDestination.find(option => option.station_id == selectedStationId);
        // console.log("🚀 ~ FormFuntion ~ idMatch:", idMatch)
        destLabel = idMatch.label;
    }

    const validateAddressData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.company_name) {
            console.log('Text input is required');
            toast.error('Company Name must not be blank');
            isValid = false;
        } else if (!inputAddress.agent_or_handler) {
            console.log('Text input is required');
            toast.error('Please select Agent or Handler');
            isValid = false;
        }
        // else if (!inputAddress.address) {
        //     console.log('Text input is required');
        //     toast.error('Address must not be blank');
        //     isValid = false;
        // } else if (!inputAddress.phone_number) {
        //     console.log('Text input is required');
        //     toast.error('Phone Number must not be blank');
        //     isValid = false;
        // } else if (!/^\d{10}$/.test(inputAddress.phone_number)) {
        //     console.log('10');
        //     toast.error('Phone Number must be 10 Digits');
        //     isValid = false;
        // } else if (!inputAddress.email) {
        //     console.log('Text input is required');
        //     toast.error('Email must not be blank');
        //     isValid = false;
        // } else if (!validateEmail(inputAddress.email)) {
        //     console.log('Invalid email address');
        //     toast.error('Invalid email address');
        //     isValid = false;
        // }
        else {
            return isValid;
        }
    };

    const addAddress = async (e) => {
        console.log('444', inputAddress);
        if (validateAddressData()) {
            e.preventDefault();
            // const newAddressID = Math.floor(Math.random() * 1000000);
            const stationid = selectedStationId;
            const NewInputAddress = { ...inputAddress, station_id: stationid };
            console.log("🚀 ~ addAddress ~ NewInputAddress:", NewInputAddress)
            // const updatedAddress = [...address, NewInputAddress];
            // if (updatedAddress) {
            //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
            //   }
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(ULDADDRESSSAVE, NewInputAddress)
                        .then(function (res) {
                            // const innerData = res;
                            // console.log("🚀 ~ .then ~ innerData:", innerData)
                            if (res.data.response_code == 200) {
                                const newAddress = res.data.response_data;
                                setAddress(newAddress);
                                fetchDestination();
                                setHandlerNames(prevHandlerNames => [
                                    ...prevHandlerNames,
                                    newAddress
                                ]);
                                setInputAddress({
                                    station_address_id: '', company_name: '', agent_or_handler: 'H', address: '', email: '', phone_number: ''
                                });
                                console.log(address);
                                addressModalClose();
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
            }

        }
    }
    // console.log('6665', handlerNames);
    // ADD ADDRESS END
    const validateFormData = () => {
        let isValid = true;

        for (let i = 0; i < formData.length; i++) {
            const uld = formData[i];
            if (!uld.flight_code) {
                toast.error('Please set Flight Code');
                isValid = false;
                break;
            }
            if (!uld.flight_number) {
                toast.error('Please set Flight Number');
                isValid = false;
                break;
            }
            if (!uld.flight_date) {
                toast.error('Please set Flight Date');
                isValid = false;
                break;
            }
            if (!uld.origin) {
                toast.error('Please set Origin');
                isValid = false;
                break;
            }
            if (!uld.departure_time_utc) {
                toast.error('Please set Departure Time');
                isValid = false;
                break;
            }
            if (!uld.destination) {
                toast.error('Please set Destination');
                isValid = false;
                break;
            }
            if (!uld.arrival_time_utc) {
                toast.error('Please set Arrival Time');
                isValid = false;
                break;
            }
        }
        return isValid;
    };

    const handleSave = async () => {
        if (validateFormData()) {
            const transformedData = formData.map(({ flight_code, flight_number, ...rest }) => ({
                ...rest,
                flight_no: flight_code + flight_number
            }));;
            console.log('Saving data:', transformedData);
            let endPoint = ''
            let payload
            if (storedData) {
                endPoint = `flight-schedule/update/${storedData.id}`
                payload = transformedData[0]
            } else {
                endPoint = 'flight-schedule/add'
                payload = { flight_schedule_data: transformedData }
            }
            try {
                const res = await withRFSToken.post(endPoint, payload);
                if (res.data.response_code == 200) {
                    toast.success(res.data.response_msg);
                    const innerData = res.data.response_data;
                    window.location.href = '/FlightSchedule';
                } else {
                    toast.error(res.data.response_msg);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };
    // Modal for Asset Type and Cancel
    const [showModal, setShowModal] = useState(false);
    const [modalRadioValue, setModalRadioValue] = useState('');
    const [modalContent, setModalContent] = useState('');
    const handleModalClose = () => { setShowModal(false); setModalRadioValue('') };

    const handleModalOpen = (contentType) => {
        setModalContent(contentType);
        setShowModal(true);
    };
    const handleConfirmation = (confirm) => {
        if (confirm) {
            setShowModal(false);
            window.location.href = '/ULDControl'
        } else {
            setShowModal(false);
        }
    }


    const handleModalUpdate = () => {
        const updatedAssetType = modalRadioValue.assetType === 'O' ? false : true;
        const updatedFormData = {
            ...formData,
            asset_type: updatedAssetType,
            uldInfo: formData.uldInfo.map(stack => ({
                ...stack,
                asset_type: updatedAssetType
            }))
        };
        setFormData(updatedFormData);
        setModalRadioValue('')
        setShowModal(false);
    };

    const [selectedFile, setSelectedFile] = useState(null);
    // const [uploading, setUploading] = useState(false);

    // const [fileData, setFileData] = useState(null);
    const [fileName, setFileName] = useState('');

    const handleFileChange = (event) => {
        // console.log("🚀 ~ handleFileChange ~ event:", event)
        setSelectedFile(event.target.files[0]);

        const input = event.target;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            setFileName(file.name);
            setSelectedFile(file);

            // const reader = new FileReader();
            // reader.onload = (e) => {
            //     setFileData(e.target.result);
            // };
            // reader.readAsText(file); // Use readAsText to read the content of the file
        }
    };
    // console.log('200', selectedFile);
    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a file first!");
            return;
        }
        // setUploading(true);
        // console.log('300', selectedFile);

        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: "binary" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = XLSX.utils.sheet_to_json(worksheet);
                console.log("🚀 ~ handleUpload ~ json:", json)
                setFormData(prevFormData => {
                    const startId = prevFormData.length + 1;

                    const transformedData = json.map((item, index, value) => {
                        let transformedConditionCode;
                        switch (item["Condition Code"]?.toString().trim().toLowerCase()) {
                            case "serviceable":
                                transformedConditionCode = "SER";
                                break;
                            case "damaged":
                                transformedConditionCode = "DAM";
                                break;
                            case "discarded":
                                transformedConditionCode = "DIS";
                                break;
                            default:
                                transformedConditionCode = item["Condition Code"]?.toString().trim() || ""; // Keep original if not matched
                        }
                        const date = new Date((item["Flight Date"] - 25569) * 86400 * 1000);
                        
                        const depTotalMinutes = Math.round(item["Departure Time (UTC)"] * 1440); // Convert fraction to total minutes
                        const depHours = Math.floor(depTotalMinutes / 60);
                        const depMinutes = depTotalMinutes % 60;

                        const arvTotalMinutes = Math.round(item["Arrival Time (UTC)"] * 1440); // Convert fraction to total minutes
                        const arvHours = Math.floor(arvTotalMinutes / 60);
                        const arvMinutes = arvTotalMinutes % 60;
                        // const 

                        return {
                            id: startId + index, // Assign ID
                            flight_code: item["Flight Code"]?.toString().trim() || "",
                            flight_number: item["Flight Number"]?.toString().trim() || "",
                            flight_date: date.toISOString().split('T')[0] || "",
                            origin: item["Origin"]?.toString().trim() || "",
                            departure_time_utc: `${String(depHours).padStart(2, '0')}:${String(depMinutes).padStart(2, '0')}` || "",
                            destination: item["Destination"]?.toString().trim() || "",
                            arrival_time_utc: `${String(arvHours).padStart(2, '0')}:${String(arvMinutes).padStart(2, '0')}` || "",
                            // condition_code: transformedConditionCode,
                            // asset_type: item["Asset Type"]?.toString().trim() === 'Owned' ? false : true
                        }
                    });

                    console.log("🚀 ~ transformedData ~ transformedData:", transformedData);


                    return [...transformedData]
                    // return [...prevFormData, ...transformedData]
                });
                setSelectedFile(null);
                setFileName('');
                // setExceljsondata(json);
                setShowModal(false);
            };
            reader.readAsBinaryString(selectedFile);
        } else {
            toast.error("All Fields Are Mandatory", { autoClose: 1000 });
        }

        // const xlFileData = new FormData();
        // xlFileData.append('uld_file', selectedFile);
        // const formData = new FormData();
        // formData.append('uld_file', selectedFile, fileName);


        // try {
        //     const res = await withRFSToken.post(IMPORTEXCEL, {uld_file:fileName} );
        //     if (res.data.response_code == 200) {
        //         toast.success('File uploaded successfully!');
        //     }

        // } catch (error) {
        //     console.error("There was an error uploading the file!", error);
        // } finally {
        //     setUploading(false);
        // }
    };
    const handleDownloadClick = () => {
        const a = document.createElement('a');
        a.href = XLSFILE;
        a.download = 'Flight_demo.xlsx'; // Name for the downloaded file
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    return (
        <>
            {console.log('formData', formData)}
            <div className="">
                <Header logo_url='/FlightSchedule' />
                <div className='main-panel'>
                    <Link to="/FlightSchedule" className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                    <div className='addstock from_width mt-3'>
                        <div className='d-flex justify-content-between adds_top'>
                            <h3>Add Flight</h3>
                            {!storedData &&
                                <Button variant="outline-info" onClick={() => handleModalOpen('import')}> <FontAwesomeIcon icon={faFileExport} /> Import List</Button>
                            }
                        </div>
                        <div className='stck_middle'>
                            {formData && formData.map((section, index) => {
                                return (
                                    <div className='d-flex mb-3 sub_add' key={index}>
                                        {/* {console.log('100', section)} */}
                                        <div>

                                            <Form.Label>Flight Number <span>*</span></Form.Label>
                                            <div className='d-flex'>
                                                <Select
                                                    options={getOwnerCodes}
                                                    onChange={(e) => handleULDInputChange(section.id, 'flight_code', e.value)}
                                                    placeholder="Flight"
                                                    className='autoslct'
                                                    name="flight_code"
                                                    value={getOwnerCodes.find(option => option.value === section.flight_code)}
                                                />
                                                <span>-</span>
                                                <Form.Control
                                                    type="text" className='ms-2'
                                                    name='flight_number'
                                                    maxLength='8' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                    value={section.flight_number}
                                                    onChange={(e) => handleULDInputChange(section.id, 'flight_number', e.target.value)}
                                                />

                                            </div>

                                        </div>
                                        <div>
                                            <Form.Label>Flight Date <span>*</span></Form.Label>
                                            <Form.Control
                                                type="date" name="flight_date"
                                                value={section.flight_date}
                                                onChange={(e) => handleULDInputChange(section.id, 'flight_date', e.target.value)}
                                            />
                                        </div>

                                        <div>
                                            <Form.Label>Origin <span>*</span></Form.Label>
                                            <Select
                                                options={getDestination}
                                                onChange={(e) => handleULDInputChange(section.id, 'origin', e.value)}
                                                placeholder="Origin"
                                                className='autoslct'
                                                name="origin"
                                                value={getDestination.find(option => option.value === section.origin)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">Departure Time (UTC) <span>*</span></label>
                                            <Form.Control
                                                type="time" name="departure_time_utc"
                                                value={section.departure_time_utc}
                                                onChange={(e) => handleULDInputChange(section.id, 'departure_time_utc', e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <Form.Label>Destination <span>*</span></Form.Label>
                                            <Select
                                                options={getDestination}
                                                onChange={(e) => handleULDInputChange(section.id, 'destination', e.value)}
                                                placeholder="Destination"
                                                className='autoslct'
                                                name="destination"
                                                value={getDestination.find(option => option.value === section.destination)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">Arrival Time (UTC) <span>*</span></label>
                                            <Form.Control
                                                type="time" name="arrival_time_utc"
                                                value={section.arrival_time_utc}
                                                onChange={(e) => handleULDInputChange(section.id, 'arrival_time_utc', e.target.value)}
                                            />

                                        </div>
                                        {/* <div>
                                            <label className="form-label">Aircraft Type<span>*</span></label>
                                            <select className="form-select" name="condition_code" value={section.condition_code} onChange={(e) => handleULDInputChange(section.id, 'condition_code', e.target.value)}>
                                                <Form.Control
                                                    type="text" name="aircraft_type"
                                                    value={section.aircraft_type}
                                                    onChange={(e) => handleULDInputChange(section.id, 'aircraft_type', e.target.value)}
                                                />
                                            </select>
                                        </div> */}
                                        <div className='imag_trash'>
                                            {formData.length > 1 && (
                                                <img src={Trash} alt='' onClick={() => removeULDStack(section.id)} />
                                            )}
                                        </div>

                                    </div>
                                )
                            })}
                            {!storedData &&
                                <div className='text-end'><Button variant="primary" className='stk_add' onClick={addULDStack}> <FontAwesomeIcon icon={faPlus} />Add Flight</Button></div>
                            }
                        </div>

                        <div className='text-center mt-5'>
                            <Button variant="light" className='stk_cancel' onClick={() => handleModalOpen('cancelForm')}>CANCEL</Button>
                            <Button variant="primary" className='stk_save' onClick={handleSave}>SAVE</Button>
                        </div>
                    </div>

                </div>
                <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        {modalContent === 'import' && (
                            <>
                                <h3>Import Excel</h3>
                                <p>Upload the filled in template to add ULDs.</p>
                                <div className='asset_midle'>

                                    <div className='upload_tmpl'>
                                        <button onClick={handleDownloadClick}>
                                            <FontAwesomeIcon icon={faDownload} />
                                            <span>Download Template (Excel) </span>
                                        </button>
                                        <div className="form-group inputDnD">
                                            <FontAwesomeIcon icon={faUpload} />
                                            <input
                                                type="file" className="form-control-file "
                                                id="inputFile"
                                                // accept=".xlsx, .xls, .csv"
                                                onChange={handleFileChange}
                                                data-title="Upload your file (Excel)" />

                                            {/* {fileData && (
                                                                        <div>
                                                                            <h4>File Data:</h4>
                                                                            <pre>{fileData}</pre>
                                                                        </div>
                                                                    )} */}
                                        </div>
                                    </div>

                                    {fileName && (
                                        <div className='rafilname'>
                                            <p>File Name: {fileName}</p>
                                        </div>
                                    )}


                                    {/* <Form.Control
                                                                type="file"
                                                                onChange={handleFileChange}
                                                                accept=".xlsx, .xls, .csv"
                                                            /> */}
                                </div>
                            </>
                        )}

                        {modalContent === 'cancelForm' && (
                            <>
                                <h3>All changes will be destroyed. </h3>
                                <p>If you proceed with the change, all data in this section will be removed.
                                    Are you sure you want to continue?</p>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>

                        {modalContent === 'assetTypeChange' ?
                            (
                                <>
                                    <Button variant='primary' onClick={handleModalUpdate}>
                                        Update Asset Type
                                    </Button>
                                </>
                            ) : (modalContent === 'import' ? (
                                <>
                                    <div className='d-flex w-50 mx-auto are_bottom'>
                                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                                            Cancel
                                        </Button>
                                        <Button variant="primary" onClick={handleUpload}>
                                            Upload
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='d-flex w-50 mx-auto are_bottom'>
                                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                                            No
                                        </Button>
                                        <Button variant="primary" onClick={() => handleConfirmation(true)}>
                                            Yes
                                        </Button>
                                    </div>
                                </>
                            ))}
                    </Modal.Footer>
                </Modal>

                <Modal show={addressModalShow} onHide={addressModalClose} centered className='addfrom'>
                    <Modal.Header closeButton onClick={addressModalClose}>
                        <Modal.Title>Add Address  - {destLabel}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <Form.Group className='mb-2'>
                            <Form.Label>Company Name</Form.Label>
                            <Form.Control type="text" onChange={handleAddressChange} name='company_name' placeholder="Company Name" />
                        </Form.Group>
                        <Form.Group className='mb-2'>
                            <Form.Label>Agent or Handler</Form.Label>
                            <Form.Check
                                inline
                                label="Agent"
                                name="agent_or_handler"
                                type='radio'
                                id='export'
                                value='A'
                                checked={inputAddress.agent_or_handler === 'A'}
                                onChange={handleAddressChange}
                                disabled
                            />

                            <Form.Check
                                inline
                                label="Handler"
                                value="H"
                                name="agent_or_handler"
                                type='radio'
                                id='import'
                                checked={inputAddress.agent_or_handler === 'H'}
                                onChange={handleAddressChange}
                            />
                        </Form.Group>
                        {inputAddress.agent_or_handler == 'A' &&
                            <>
                                <Form.Group className='mb-2'>
                                    <Form.Check
                                        inline
                                        label="External"
                                        name="agent_type"
                                        type='radio'
                                        id='external'
                                        value='E'
                                        checked={inputAddress.agent_type === 'E'}
                                        onChange={handleAddressChange}
                                    />

                                    <Form.Check
                                        inline
                                        label="Internal"
                                        value="I"
                                        name="agent_type"
                                        type='radio'
                                        id='internal'
                                        checked={inputAddress.agent_type === 'I'}
                                        onChange={handleAddressChange}
                                    />

                                </Form.Group>
                            </>
                        }
                        <Form.Group className='mb-2'>
                            <Form.Label>Address </Form.Label>
                            <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" />
                        </Form.Group>
                        <Form.Group className='mb-2'>
                            <Form.Label>Email ID</Form.Label>
                            <Form.Control type="text" onChange={handleAddressChange} name='email' placeholder="E-mail" />
                        </Form.Group>
                        <Form.Group className='mb-2'>
                            <Form.Label>Telephone No</Form.Label>
                            <Form.Control type="number" onChange={handleAddressChange} name='phone_number' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }} placeholder="Number" />
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={addAddress}  >
                            Add Address
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    )
}

export default AddFlight